import { Component, OnInit } from '@angular/core';
import { ParticipantLeadsListComponent } from '../../../participant-leads-list/participant-leads-list.component';
import { ListTableComponent } from "../../../../shared/components/list-table/list-table.component";
import { PageConfig } from '../../../../shared/authorization/auth.config';
import { Router } from '@angular/router';
import { ClaimsService } from '../../../../services/claims.service';
import { SectionsService } from '../../../../services/sections.service';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../../shared/authorization/authorization.service';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-files-list',
  standalone: true,
  imports: [ListTableComponent],
  templateUrl: './files-list.component.html',
  styleUrl: './files-list.component.css'
})
export class FilesListComponent implements OnInit {
  sharedDataKey: string = STATIC_DATA.SHARED_BILLING_FILES_DATA;
  pageId: string = PAGE_CONSTANTS.BILLING_FILES_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  programName!: string;
  lazyLoad = true;

  constructor(
    private router: Router,private authService: AuthorizationService,
    private sharedDataService: SharedDataService, private authUtility: AuthorizationUtility,
    private sectionService: SectionsService, private claimsService: ClaimsService,
    private userService: UserService
  ) {
  }

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }
  rowClicked(rowDetail: any) {
    this.userService.setLeadEntry('batches');
    console.log('rowDetail', rowDetail);
    if(!rowDetail.pmPmFlg) {
      this.router.navigate(['/home/viewClaimsList'], { state: { batchId: rowDetail.tasBillingBatchMasterId, pmpmflg: rowDetail.pmPmFlg } })
    } else {
      this.router.navigate(['/home/billingPmpmClaimsList'], { state: { batchId: rowDetail.tasBillingBatchMasterId, pmpmflg: rowDetail.pmPmFlg } })
    }
  }

  private setPageAccess() {
    const pageConfig = this.authUtility.getPageConfig(this.pageId);
    if (!pageConfig || !pageConfig.pageName) {
      this.authService.fetchPageAuthorization(this.programName, this.pageId, "LIST").subscribe(response => {
        this.setRestrictions(response);
      })
    } else {
      this.setRestrictions(pageConfig);
    }
  }

  private setRestrictions(pageConfig: PageConfig) {
    if (pageConfig) {
      this.columnsToBeHidden = this.authUtility.getHiddenColumns(pageConfig, this.pageId);
      this.actionsToBeHidden = this.authUtility.getHiddenActions(pageConfig, this.pageId);
    }
    this.isPageRestrictionLoaded = true;
  }

  clearData() {
    this.sharedDataService.clearData(this.sharedDataKey);
  }
}
